<template>
  <div class="record-space ml5 mt5">
    <el-form ref="queryForm" class="pagination-table-query-form" :inline="true" @keyup.enter.native="handleFormQuery()">
      <el-form-item label="服务器">
        <el-select v-model.number="tableQueryParams.serverId" placeholder="请选择录像存储服务器">
          <el-option
            v-for="item in serversIncludeAll"
            :key="item.id"
            :value="item.id"
            :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleFormQuery()" type="primary">查 询</el-button>
        <el-button @click="resetQueryForm()">重 置</el-button>
      </el-form-item>
    </el-form>

    <div class="pagination-table-button-container">
      <el-button @click="handleAdd" type="primary">新 增</el-button>
      <el-button type="primary" @click="handleDelete()" :disabled="!tableSelectedIds.length">批量删除</el-button>
      <el-button type="primary" @click="handleImport()">导 入</el-button>
      <el-button type="primary" @click="handleExport()">导 出</el-button>
    </div>
    <div class="pagination-table-container">
      <el-table ref="table"
                :data="tableData"
                border style="width: 100%"
                v-loading="loading"
                element-loading-text="努力加载中..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                @selection-change="handleTableSelectionChange">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="本地路径" prop="localPath" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="虚拟路径" prop="virtualPath" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="服务器" prop="serverId" :show-overflow-tooltip="true">
          <template slot-scope="scope">{{ getNameById(scope.row.serverId, $globalData.servers) }}</template>
        </el-table-column>
        <el-table-column label="空间大小(GB)" prop="totalSize">
          <template slot-scope="scope">{{ gByteFromByte(scope.row.totalSize) }}</template>
        </el-table-column>
        <el-table-column label="可用大小(GB)" prop="availableSize">
          <template slot-scope="scope">{{ gByteFromByte(scope.row.availableSize) }}</template>
        </el-table-column>
        <el-table-column label="已用大小(GB)" prop="usedSize">
          <template slot-scope="scope">{{ gByteFromByte(scope.row.usedSize) }}</template>
        </el-table-column>
        <el-table-column label="保留大小(GB)" prop="reservedSize">
          <template slot-scope="scope">{{ gByteFromByte(scope.row.reservedSize) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button
              class="col-btn"
              type="text"
              icon="el-icon-edit"
              @click="handleModify(scope.row)"
            >修改
            </el-button>
            <el-button
              class="col-btn"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleCurrentPageChange"
        @size-change="handlePageSizeChange"
        :current-page.sync="tableQueryParams.pageNum"
        :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
        :page-size.sync="tableQueryParams.pageSize"
        prev-text="上一页"
        next-text="下一页"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotalRow">
      </el-pagination>
    </div>

    <!--新增或修改录像空间-->
    <el-dialog
      :title="modalForm.id ? '修改录像空间' : '新增录像空间'"
      :visible="modalOpen"
      :append-to-body="true"
      width="600px"
      :before-close="handleModalCancel"
    >
      <el-form ref="modalForm" inline class="record-space-form" :model="modalForm" :rules="formRules" labelWidth="120px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="modalForm.name" placeholder="请输入名称" clearable :style="{width: '300px'}"></el-input>
        </el-form-item>
        <el-form-item label="本地路径" prop="localPath">
          <el-input v-model="modalForm.localPath" placeholder="请输入本地路径" clearable :style="{width: '300px'}"></el-input>
        </el-form-item>
        <el-form-item label="虚拟路径" prop="virtualPath">
          <el-input v-model="modalForm.virtualPath" placeholder="请输入虚拟路径" clearable :style="{width: '300px'}"></el-input>
        </el-form-item>
        <el-form-item label="服务器" prop="serverId">
          <el-select v-model="modalForm.serverId" placeholder="请选择服务器" :style="{width: '300px'}">
            <el-option v-for="(item, index) in $globalData.servers"
                       :key="'server' + index"
                       :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="保留大小" prop="reservedSize">
          <el-input v-model="modalForm.reservedSize" placeholder="请输入保留大小" clearable :style="{width: '300px'}">
            <template slot="append">GB</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleModalSubmit" type="primary">确定</el-button>
        <el-button @click="handleModalCancel">取消</el-button>
      </div>
    </el-dialog>

    <!-- 数据导入对话框 -->
    <el-dialog :title="upload.title" :append-to-body="true" :visible.sync="upload.open" width="400px">
      <el-upload
        ref="upload"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="upload.headers"
        :action="upload.url + '?updateSupport=' + upload.updateSupport"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileUploadSuccess"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          <el-checkbox v-model="upload.updateSupport" style="vertical-align: middle;">是否更新已经存在记录</el-checkbox>
          <el-link type="info" @click="handleDownloadTemplate">下载模板</el-link>
        </div>
        <div class="el-upload__tip" style="color:red" slot="tip">提示：仅允许导入“xls”或“xlsx”格式文件！</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleFileUploadSubmit">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import RecordSpace from './RecordSpace.js'

export default RecordSpace
</script>

<style lang="scss">
  // @import "recordSpace";
</style>



// WEBPACK FOOTER //
// src/views/system/recordSpace/RecordSpace.vue